export function slugify(text) {
    if (!text) return '';
    return text
        .toString()
        .toLowerCase()
        .replace(/[^\w\s-]/g, ' ')
        .trim()
        .replace(/\s+/g, '-');
}

export const CATEGORY_MAP = [
    { id: 1, name: 'Alat Pertukangan', slug: 'alat-pertukangan' },
    { id: 2, name: 'Bahan Bangunan', slug: 'bahan-bangunan' },
    { id: 3, name: 'Cat', slug: 'cat' },
    { id: 4, name: 'Dapur', slug: 'dapur' },
    { id: 5, name: 'Hardware', slug: 'hardware' },
    { id: 6, name: 'Hobi', slug: 'hobi' },
    { id: 7, name: 'Kamar Mandi', slug: 'kamar-mandi' },
    { id: 8, name: 'Lantai & Dinding', slug: 'lantai-dinding' },
    { id: 9, name: 'Listrik & Pencahayaan', slug: 'listrik-pencahayaan' },
    { id: 10, name: 'Peralatan Rumah Tangga', slug: 'peralatan-rumah-tangga' },
    { id: 11, name: 'Pintu & Jendela', slug: 'pintu-jendela' },
    { id: 12, name: 'Pipa Saluran Air', slug: 'pipa-saluran-air' },
    { id: 13, name: 'Furniture', slug: 'furniture' },
    { id: 14, name: 'Kawat dan Besi', slug: 'kawat-dan-besi' },
];

export function getCategoryById(id) {
    if (!id) return null;
    return CATEGORY_MAP.find((c) => String(c.id) === String(id)) || null;
}

export function getCategoryBySlug(slug) {
    if (!slug) return null;
    const clean = slugify(slug);
    return CATEGORY_MAP.find((c) => c.slug === clean || slugify(c.name) === clean) || null;
}

export const url = {
    home: () => '/',

    catalog: () => '/shop/category',

    category: (category, name) => {
        if (!category) return '/shop/category';

        if (
            category === 'all' ||
            category?.id === 'all' ||
            category?.slug === 'all' ||
            category?.isAll ||
            category?.name === 'Semua Kategori'
        ) {
            return {
                pathname: '/shop/category',
                state: {},
                toString: () => '/shop/category',
            };
        }

        let id = null;
        let categoryName = name || '';

        if (typeof category === 'object') {
            id = category.id || category.category_id || category.kategori_id;
            categoryName = categoryName || category.name || category.kategori_name || category.title;
        } else if (typeof category === 'number' || (typeof category === 'string' && /^\d+$/.test(category))) {
            id = category;
            const mapped = getCategoryById(id);
            if (mapped) categoryName = mapped.name;
        } else if (typeof category === 'string') {
            return category.startsWith('/') ? category : `/shop/category/${category}`;
        }

        const slug = slugify(categoryName) || id;

        if (slug && id && typeof window !== 'undefined') {
            try {
                if (window.sessionStorage) window.sessionStorage.setItem(`cat_slug_${slug}`, String(id));
                if (window.localStorage) window.localStorage.setItem(`cat_slug_${slug}`, String(id));
            } catch (e) {}
        }

        return {
            pathname: `/shop/category/${slug}`,
            state: { categoryId: id },
            toString: () => `/shop/category/${slug}`,
        };
    },

    product: (product, name) => {
        if (!product) return '/shop/products';

        let id = null;
        let productName = name || '';

        if (typeof product === 'object') {
            id = product.id_is || product.id;
            productName = productName || product.item_name || product.name || product.title;
        } else if (typeof product === 'number' || (typeof product === 'string' && /^\d+$/.test(product))) {
            id = product;
        } else if (typeof product === 'string') {
            return product.startsWith('/') ? product : `/shop/products/${product}`;
        }

        const slug = slugify(productName) || id;

        if (slug && id && typeof window !== 'undefined') {
            try {
                if (window.sessionStorage) window.sessionStorage.setItem(`prod_slug_${slug}`, String(id));
                if (window.localStorage) window.localStorage.setItem(`prod_slug_${slug}`, String(id));
            } catch (e) {}
        }

        return {
            pathname: `/shop/products/${slug}`,
            state: { productId: id },
            toString: () => `/shop/products/${slug}`,
        };
    },

    kategori: (kategori) => `/shop/kategori/${kategori}`,

    Pembayarans: (pembayarans) => `/accounts/order-produk/${pembayarans}`,

    Pembayaran: (pembayaran) => `/account/order-produk/${pembayaran}`,

    alamatsurvey: (alamatsurvey) => `/aplikator/alamat-survey/${alamatsurvey}`,
    
    detailobservasi: (detailobservasi) => `/aplikator/detail-observasi/${detailobservasi}`,
    
    bayardp: (bayardp) => `/aplikator/bayar-dp/${bayardp}`,

    buktibayardp: (buktibayardp) => `/aplikator/bukti-bayar-dp/${buktibayardp}`,

    emailakses: (emailakses) => `/aplikator/email-akses-klien/${emailakses}`,

    buktipelunasan: (buktipelunasan) => `/aplikator/pelunasan/${buktipelunasan}`,

    detailtransaksiaplikator: (detailtransaksiaplikator) => `/aplikator/detail-transaksi/${detailtransaksiaplikator}`,

    revisiaplikator: (revisiaplikator) => `/addendum/create/${revisiaplikator}`,

    cekdetailrevisi: (cekdetailrevisi) => `/addendum/hasil-revisi/${cekdetailrevisi}`,

    buktibayaraddendum: (buktibayaraddendum) => `/addendum/bukti-bayar/${buktibayaraddendum}`,

    addendumdetail: (addendumdetail) => `/addendum/detail-revisi/${addendumdetail}`,

    addressid: (addressid) => `/account/addresses/${addressid}`,

    validasirab: (validasirab) => `/aplikator/validasi-rab/${validasirab}`,

    transactioncode: (transactioncode) => `/account/orders/${transactioncode}`,



};

export function getCategoryParents(category) {
    return category.parent ? [...getCategoryParents(category.parent), category.parent] : [];
}
